export const BRAND_UPDATED = "brand/updated";
export const FETCH_BRAND_REQUEST = "fetch/brand/request";
export const FETCH_BRAND_SUCCESS = "fetch/brand/success";
export const FETCH_BRAND_FAILURE = "fetch/brand/failure";
